// extracted by mini-css-extract-plugin
export var content = "TextAgendaLayout-module--content--e09e2";
export var groupContent = "TextAgendaLayout-module--groupContent--6145d";
export var heading = "TextAgendaLayout-module--heading--ebb0d";
export var image = "TextAgendaLayout-module--image--699ef";
export var moreInfo = "TextAgendaLayout-module--moreInfo--bb42c";
export var wrapper = "TextAgendaLayout-module--wrapper--718eb";